import { z } from 'zod'
import { Id } from './primitives'

export const PUSH_ENDPOINT_MAX_CHARS = 2048
export const PUSH_KEY_MAX_CHARS = 256

export const PUSH_SERVICE_HOSTS: readonly string[] = [
  'fcm.googleapis.com',
  'push.services.mozilla.com',
  'notify.windows.com',
  'push.apple.com',
]

const PushEndpoint = z.url({ protocol: /^https$/ }).max(PUSH_ENDPOINT_MAX_CHARS)

const isPushServiceHost = (endpoint: string): boolean => {
  const { hostname } = new URL(endpoint)
  return PUSH_SERVICE_HOSTS.some((host) => hostname === host || hostname.endsWith(`.${host}`))
}

const PushServiceEndpoint = PushEndpoint.refine(isPushServiceHost, {
  message: 'endpoint must belong to a browser push service',
})

const PushKey = z.string().min(1).max(PUSH_KEY_MAX_CHARS)

export const PushSubscriptionInput = z.object({
  endpoint: PushServiceEndpoint,
  keys: z.object({ p256dh: PushKey, auth: PushKey }),
})
export type PushSubscriptionInput = z.infer<typeof PushSubscriptionInput>

export const PushUnsubscribeInput = z.object({ endpoint: PushEndpoint })
export type PushUnsubscribeInput = z.infer<typeof PushUnsubscribeInput>

export const PushPublicKeyResponse = z.object({ publicKey: z.string().min(1).nullable() })
export type PushPublicKeyResponse = z.infer<typeof PushPublicKeyResponse>

const AppPath = z.string().regex(/^\/(?![/\\])/)

export const PushNotificationPayload = z.object({
  title: z.string().min(1),
  body: z.string(),
  url: AppPath,
  tenantId: Id,
  conversationId: Id,
})
export type PushNotificationPayload = z.infer<typeof PushNotificationPayload>
